import { render, staticRenderFns } from "./imprimirFavsCaso.vue?vue&type=template&id=4ad05e48&scoped=true&lang=html&"
import script from "./imprimirFavsCaso.vue?vue&type=script&lang=js&"
export * from "./imprimirFavsCaso.vue?vue&type=script&lang=js&"
import style0 from "./imprimirFavsCaso.vue?vue&type=style&index=0&id=4ad05e48&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad05e48",
  null
  
)

export default component.exports